// Data service - generates user-specific dynamic data

const hostDataMap = {
  'host_1': {
    name: 'Athik Ahamed',
    location: 'Loftworks Coffee',
    city: 'Chennai',
    totalBookings: 127,
    rating: 4.8,
    superhost: true,
    revenue: 45230,
    occupancy: 78,
  },
  'host_2': {
    name: 'Priya Kapoor',
    location: 'Indie Hub',
    city: 'Bangalore',
    totalBookings: 95,
    rating: 4.9,
    superhost: true,
    revenue: 38500,
    occupancy: 82,
  },
  'host_3': {
    name: 'Raj Patel',
    location: 'Tech Commons',
    city: 'Bangalore',
    totalBookings: 42,
    rating: 4.6,
    superhost: false,
    revenue: 18900,
    occupancy: 65,
  },
  'host_4': {
    name: 'Vikram Singh',
    location: 'CreativeLab Delhi',
    city: 'Delhi',
    totalBookings: 156,
    rating: 4.85,
    superhost: true,
    revenue: 52100,
    occupancy: 85,
  },
  'host_5': {
    name: 'Neha Gupta',
    location: 'Workspace Mumbai',
    city: 'Mumbai',
    totalBookings: 72,
    rating: 4.7,
    superhost: false,
    revenue: 31200,
    occupancy: 71,
  },
  'host_6': {
    name: 'Arun Kumar',
    location: 'Coworking Hyderabad',
    city: 'Hyderabad',
    totalBookings: 203,
    rating: 4.9,
    superhost: true,
    revenue: 58900,
    occupancy: 88,
  },
  'host_sneha': {
    name: 'Sneha Reddy',
    location: 'Sneha\'s Premium Workspace',
    city: 'Bangalore',
    totalBookings: 98,
    rating: 4.8,
    superhost: true,
    revenue: 35600,
    occupancy: 79,
  },
  'host_aarav': {
    name: 'Aarav Menon',
    location: 'Aarav\'s Business Hub',
    city: 'Bangalore',
    totalBookings: 145,
    rating: 4.85,
    superhost: true,
    revenue: 48700,
    occupancy: 81,
  },
};

const guestNames = ['Aarav Menon', 'Sneha Reddy', 'Karthik Varma', 'Divya Nair', 'Anjali Iyer', 'Vikram Shah', 'Team Northstar'];

// Generate bookings for a specific host
export function getHostBookings(hostId) {
  const hostData = hostDataMap[hostId];
  if (!hostData) return [];

  const bookingsData = {
    'host_1': [ // Athik Ahamed
      { id: 'BK-001', guest: 'Aarav Menon', initials: 'AM', time: '9:00 AM - 1:00 PM', status: 'checked-in', amount: 499, date: 'Today', duration: '4h', desks: 1, start: 9, end: 13, channel: 'app', note: 'Regular guest', c: 'blue' },
      { id: 'BK-002', guest: 'Sneha Reddy', initials: 'SR', time: '10:00 AM - 11:00 AM', status: 'checked-in', amount: 149, date: 'Today', duration: '1h', desks: 1, start: 10, end: 11, channel: 'web', note: 'Conference call setup', c: 'green' },
      { id: 'BK-003', guest: 'Karthik Varma', initials: 'KV', time: '2:00 PM - 6:00 PM', status: 'upcoming', amount: 399, date: 'Today', duration: '4h', desks: 2, start: 14, end: 18, channel: 'app', note: 'Team meeting', c: 'amber' },
      { id: 'BK-004', guest: 'Divya Nair', initials: 'DN', time: '4:00 PM - 7:00 PM', status: 'upcoming', amount: 299, date: 'Today', duration: '3h', desks: 1, start: 16, end: 19, channel: 'web', note: '', c: 'gray' },
      { id: 'BK-005', guest: 'Anjali Iyer', initials: 'AI', time: '11:00 AM - 3:00 PM', status: 'upcoming', amount: 399, date: 'Tomorrow', duration: '4h', desks: 1, start: 11, end: 15, channel: 'app', note: 'Client presentation', c: 'purple' },
      { id: 'BK-006', guest: 'Vikram Shah', initials: 'VS', time: '9:00 AM - 5:00 PM', status: 'completed', amount: 799, date: 'Yesterday', duration: '8h', desks: 2, start: 9, end: 17, channel: 'app', note: 'Full day workshop', seats: 2, repeat: true },
      { id: 'BK-007', guest: 'Team Northstar', initials: 'TN', time: '10:00 AM - 4:00 PM', status: 'completed', amount: 1199, date: 'Last week', duration: '6h', desks: 4, start: 10, end: 16, channel: 'web', note: 'Team offsite', seats: 4 },
    ],
    'host_sneha': [ // Sneha Reddy
      { id: 'BK-101', guest: 'Priya Singh', initials: 'PS', time: '8:00 AM - 12:00 PM', status: 'checked-in', amount: 449, date: 'Today', duration: '4h', desks: 1, start: 8, end: 12, channel: 'app', note: 'Freelancer', c: 'blue' },
      { id: 'BK-102', guest: 'Rajesh Kumar', initials: 'RK', time: '12:00 PM - 3:00 PM', status: 'checked-in', amount: 299, date: 'Today', duration: '3h', desks: 1, start: 12, end: 15, channel: 'web', note: 'One-time booking', c: 'green' },
      { id: 'BK-103', guest: 'Meera Patel', initials: 'MP', time: '3:00 PM - 7:00 PM', status: 'upcoming', amount: 399, date: 'Today', duration: '4h', desks: 1, start: 15, end: 19, channel: 'app', note: 'Weekly regular', c: 'amber', repeat: true },
      { id: 'BK-104', guest: 'Aditya Sharma', initials: 'AS', time: '9:00 AM - 6:00 PM', status: 'upcoming', amount: 699, date: 'Tomorrow', duration: '9h', desks: 2, start: 9, end: 18, channel: 'app', note: 'Full day', seats: 2 },
      { id: 'BK-105', guest: 'Zara Khan', initials: 'ZK', time: '10:00 AM - 2:00 PM', status: 'completed', amount: 349, date: 'Yesterday', duration: '4h', desks: 1, start: 10, end: 14, channel: 'web', note: 'Interview prep' },
    ],
    'host_aarav': [ // Aarav Menon
      { id: 'BK-201', guest: 'Sanjana Gupta', initials: 'SG', time: '9:00 AM - 12:00 PM', status: 'checked-in', amount: 399, date: 'Today', duration: '3h', desks: 1, start: 9, end: 12, channel: 'web', note: 'Design work', c: 'purple' },
      { id: 'BK-202', guest: 'Rohan Das', initials: 'RD', time: '1:00 PM - 5:00 PM', status: 'checked-in', amount: 449, date: 'Today', duration: '4h', desks: 1, start: 13, end: 17, channel: 'app', note: 'Development', c: 'blue' },
      { id: 'BK-203', guest: 'Neha Sharma', initials: 'NS', time: '10:00 AM - 3:00 PM', status: 'upcoming', amount: 399, date: 'Today', duration: '5h', desks: 2, start: 10, end: 15, channel: 'app', note: 'Project meeting', seats: 2 },
      { id: 'BK-204', guest: 'Arjun Singh', initials: 'AS', time: '9:00 AM - 5:00 PM', status: 'upcoming', amount: 799, date: 'Tomorrow', duration: '8h', desks: 3, start: 9, end: 17, channel: 'web', note: 'Team retreat', seats: 3 },
      { id: 'BK-205', guest: 'Pooja Mishra', initials: 'PM', time: '11:00 AM - 4:00 PM', status: 'completed', amount: 399, date: 'Yesterday', duration: '5h', desks: 1, start: 11, end: 16, channel: 'app', note: 'Client meeting' },
    ]
  };

  return bookingsData[hostId] || [];
}

// Generate notifications for a specific host
export function getHostNotifications(hostId) {
  const hostData = hostDataMap[hostId];
  if (!hostData) return [];

  return [
    { id: 'N1', type: 'booking', title: 'New Booking', desc: 'Aarav Menon booked your space today', unread: true, time: '2 hours ago' },
    { id: 'N2', type: 'review', title: 'New Review', desc: 'You received a 5-star review', unread: true, time: '1 hour ago' },
    { id: 'N3', type: 'revenue', title: 'Payout Ready', desc: `Your weekly payout of ₹${hostData.revenue} is ready`, unread: false, time: '30 min ago' },
  ];
}

// Generate pending actions for a specific host
export function getHostActions(hostId) {
  return [
    { id: 'A1', type: 'cancellation', title: 'Cancellation Request', detail: 'Guest requested to cancel booking BK-9M1RT', time: '18 min ago', amount: 699 },
    { id: 'A2', type: 'review', title: 'Review Response Needed', detail: 'Respond to Sneha Reddy\'s review to maintain rating', time: '2h ago' },
    { id: 'A3', type: 'reschedule', title: 'Reschedule Request', detail: 'Guest wants to move booking from Fri 1pm to Fri 4pm', time: '4h ago' },
  ];
}

// Generate analytics for a specific host
export function getHostAnalytics(hostId) {
  const hostData = hostDataMap[hostId];
  if (!hostData) return null;

  return {
    revenue: hostData.revenue,
    occupancy: hostData.occupancy,
    rating: hostData.rating,
    totalBookings: hostData.totalBookings,
    weeklyData: [
      { day: 'Mon', occ: 75 },
      { day: 'Tue', occ: 82 },
      { day: 'Wed', occ: 78 },
      { day: 'Thu', occ: 85 },
      { day: 'Fri', occ: 88 },
      { day: 'Sat', occ: 92 },
      { day: 'Sun', occ: 71 },
    ],
  };
}

// Get host profile data
export function getHostProfile(hostId) {
  return hostDataMap[hostId] || null;
}
